/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-source',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoSourceComponent extends NestedOption {
    @Input()
    get grouping(): string {
        return this._getOption('grouping');
    }
    set grouping(value: string) {
        this._setOption('grouping', value);
    }

    @Input()
    get layer(): string {
        return this._getOption('layer');
    }
    set layer(value: string) {
        this._setOption('layer', value);
    }


    protected get _optionPath() {
        return 'source';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoSourceComponent
  ],
  exports: [
    DxoSourceComponent
  ],
})
export class DxoSourceModule { }
